import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum VerificationMetricPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const VerificationMetricResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.VERIFICATION_METRIC).default(ResourceType.VERIFICATION_METRIC),
    description: z.string(),
});
export const VerificationMetricMutationResourceSchema = getMutationSchema(VerificationMetricResourceSchema);

export type VerificationMetricResource = z.infer<typeof VerificationMetricResourceSchema>;

export const defaultVerificationMetricResource: VerificationMetricResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.VERIFICATION_METRIC,
    description: '',
};

export function useVerificationMetricActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/verification-metric',
            ResourceType.VERIFICATION_METRIC,
            VerificationMetricResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/verification-metric',
            ResourceType.VERIFICATION_METRIC,
            VerificationMetricResourceSchema
        ),
    };
}
